import React from 'react';
import imagenFondo from '../assets/logo_elecnor.jpg';

const CompraPDFTemplate = React.forwardRef(({ solicitud }, ref) => {
    if (!solicitud) return null;

    // --- FUNCIONES DE APOYO ---
    const renderCheckbox = (isChecked) => (
        <span style={{
            display: 'inline-block',
            width: '12px',
            height: '12px',
            border: '1px solid #003366',
            textAlign: 'center',
            lineHeight: '11px',
            fontSize: '10px',
            fontWeight: 'bold',
            backgroundColor: isChecked ? '#e6f0fa' : '#fff',
            color: '#003366',
            marginRight: '8px'
        }}>
            {isChecked ? 'X' : ''}
        </span>
    );

    const renderFirma = (orden, titulo, subtitulo, width = '25%') => {
        const firma = (solicitud.firmas || []).find(f => f.orden_flujo === orden);
        
        return (
            <td style={{ 
                border: '1px solid #003366', 
                width: width,
                verticalAlign: 'top', 
                padding: '6px', 
                backgroundColor: '#fff' 
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '140px', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#003366', textAlign: 'center', borderBottom: '1px solid #ccc', paddingBottom: '4px', marginBottom: '4px' }}>
                        {titulo}
                        <br/>
                        <span style={{ fontSize: '8px', color: '#555', fontWeight: 'normal' }}>{subtitulo}</span>
                    </div>

                    {firma ? (
                        <>
                            <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {firma.firma_path && (
                                    <img src={firma.firma_path} alt="Firma" style={{ maxHeight: '65px', maxWidth: '95%', objectFit: 'contain' }} />
                                )}
                            </div>
                            <div style={{ fontSize: '8px', textAlign: 'center', color: '#333', borderTop: '1px dotted #ccc', paddingTop: '4px' }}>
                                <strong>Por:</strong> {firma.nombre} {firma.apellidos}<br/>
                                <strong>Fecha:</strong> {new Date(firma.fecha_hora).toLocaleString('es-ES')}
                            </div>
                        </>
                    ) : (
                        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontStyle: 'italic', fontSize: '10px' }}>
                            Pendiente
                        </div>
                    )}
                </div>
            </td>
        );
    };

    return (
        <div ref={ref} style={styles.page}>
            
            {/* --- CABECERA --- */}
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '15px' }}>
                <tbody>
                    <tr>
                        <td style={{ width: '25%', border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '10px' }}>
                            <img src={imagenFondo} alt="Logo" style={{ maxHeight: '50px' }} /> 
                        </td>
                        <td style={{ width: '75%', border: '1px solid #003366', textAlign: 'center', verticalAlign: 'middle', padding: '10px', backgroundColor: '#e6f0fa' }}>
                            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#003366', textTransform: 'uppercase' }}>
                                FICHA DE SOLICITUD DE MATERIAL
                            </div>
                            <div style={{ fontSize: '11px', color: '#003366', marginTop: '4px' }}>
                                Departamento de Almacén y Gestión de Compras | Solicitud #{solicitud.id_solicitud} {solicitud.titulo ? `| ${solicitud.titulo}` : ''}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* --- 1. DATOS DE LA SOLICITUD --- */}
            <div style={styles.sectionTitle}>1. DATOS DE LA SOLICITUD</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #003366', marginBottom: '15px' }}>
                <tbody>
                    <tr>
                        <td style={{ ...styles.th, width: '20%' }}>FECHA:</td>
                        <td style={{ ...styles.td, width: '30%', fontWeight: 'bold' }}>
                            {new Date(solicitud.fecha_creacion).toLocaleDateString('es-ES')}
                        </td>
                        <td style={{ ...styles.th, width: '20%' }}>TALLER / DPTO:</td>
                        <td style={{ ...styles.td, width: '30%', fontWeight: 'bold', textTransform: 'uppercase' }}>
                            {solicitud.departamento}
                        </td>
                    </tr>
                    <tr>
                        <td style={styles.th}>SOLICITANTE:</td>
                        <td colSpan="3" style={{ ...styles.td, fontWeight: 'bold' }}>
                            {solicitud.solicitante_nombre} {solicitud.solicitante_apellidos}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* --- 2. TIPO DE SOLICITUD --- */}
            <div style={styles.sectionTitle}>2. TIPO DE SOLICITUD (Marcar con X)</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #003366', marginBottom: '15px', backgroundColor: '#fff' }}>
                <tbody>
                    <tr>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'REPUESTOS')}
                                <span><strong>REPUESTOS</strong> (Requiere indicar Nº de OT y Planta)</span>
                            </div>
                        </td>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'CONSUMIBLES')}
                                <span><strong>CONSUMIBLES</strong> (Petición agrupada de taller - Stock &lt; 20%)</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'HERRAMIENTAS')}
                                <span><strong>HERRAMIENTAS</strong> (Reposición semestral: Julio/Enero)</span>
                            </div>
                        </td>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'HERRAMIENTA_ESPECIFICA')}
                                <span><strong>HERRAMIENTA ESPECÍFICA</strong> (Urgente / Uso concreto)</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'MATERIAL_OFICINA')}
                                <span><strong>MATERIAL OFICINA</strong> Y SERVICIOS GRALES</span>
                            </div>
                        </td>
                        <td style={{ ...styles.td, width: '50%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'REPOSICION_EPIS')}
                                <span><strong>REPOSICIÓN</strong> STOCKS EPIS</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2" style={styles.td}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {renderCheckbox(solicitud.tipo_solicitud === 'OTROS')}
                                <span><strong>OTROS</strong> (Especificar en justificación)</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* --- 3. DETALLES DEL MATERIAL --- */}
            <div style={styles.sectionTitle}>3. DETALLES DEL MATERIAL</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #003366', marginBottom: '15px' }}>
                <thead>
                    <tr>
                        <th style={{ ...styles.thCenter, width: '15%' }}>ARTÍCULO</th>
                        <th style={{ ...styles.thCenter, width: '40%' }}>DESCRIPCIÓN / ESPECIFICACIONES</th>
                        <th style={{ ...styles.thCenter, width: '15%' }}>CANTIDAD</th>
                        <th style={{ ...styles.thCenter, width: '15%' }}>Nº OT</th>
                        <th style={{ ...styles.thCenter, width: '15%' }}>PLANTA / DESTINO</th>
                    </tr>
                </thead>
                <tbody>
                    {(() => {
                        const mats = solicitud.materiales || [];
                        const rows = [];
                        const totalRows = Math.max(3, mats.length);
                        
                        for (let i = 0; i < totalRows; i++) {
                            const m = mats[i] || { articulo: '', descripcion: '', cantidad: '', ot_referencia: '', planta_destino: '' };
                            rows.push(
                                <tr key={i}>
                                    <td style={{ ...styles.td, textAlign: 'center', fontWeight: 'bold' }}>{m.articulo || ''}</td>
                                    <td style={{ ...styles.td, fontWeight: 'bold' }}>{m.descripcion}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{m.cantidad}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{m.ot_referencia}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{m.planta_destino}</td>
                                </tr>
                            );
                        }
                        return rows;
                    })()}
                </tbody>
            </table>

            {/* --- 4. JUSTIFICACIÓN DE LA NECESIDAD --- */}
            <div style={styles.sectionTitle}>
                4. JUSTIFICACIÓN DE LA NECESIDAD
            </div>
            <div style={{ fontSize: '9px', fontStyle: 'italic', color: '#555', marginBottom: '4px' }}>
                (Explicar brevemente el motivo de la compra o el trabajo específico a realizar.).
            </div>
            <div style={{ border: '1px solid #003366', padding: '10px', minHeight: '60px', backgroundColor: '#fff', marginBottom: '15px', fontSize: '11px', whiteSpace: 'pre-wrap' }}>
                {solicitud.justificacion || ''}
            </div>

            {/* --- 5. GESTIÓN DE OFERTA --- */}
            <div style={styles.sectionTitle}>5. GESTIÓN DE OFERTA / ADMINISTRACIÓN</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #003366', marginBottom: '20px' }}>
                <tbody>
                    <tr>
                        <td style={{ ...styles.th, width: '25%' }}>OFERTA RECIBIDA:</td>
                        <td style={{ ...styles.td, width: '25%' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {renderCheckbox(solicitud.oferta_recibida === 1)} SÍ
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {renderCheckbox(solicitud.oferta_recibida === 0)} NO
                                </span>
                            </div>
                        </td>
                        <td style={{ ...styles.th, width: '15%' }}>PROVEEDOR:</td>
                        <td style={{ ...styles.td, width: '35%', fontWeight: 'bold' }}>{solicitud.proveedor || ''}</td>
                    </tr>
                    <tr>
                        <td style={styles.th}>REF. PRESUPUESTO:</td>
                        <td style={{ ...styles.td, fontWeight: 'bold' }}>{solicitud.ref_presupuesto || ''}</td>
                        <td style={styles.th}>CÓDIGO COSTES:</td>
                        <td style={{ ...styles.td, fontWeight: 'bold', color: '#d32f2f' }}>{solicitud.codigo_costes || ''}</td>
                    </tr>
                    <tr>
                        <td style={styles.th}>Nº DE PEDIDO:</td>
                        <td colSpan="3" style={{ ...styles.td, fontWeight: 'bold', color: '#2e7d32' }}>{solicitud.numero_pedido || ''}</td>
                    </tr>
                </tbody>
            </table>

            {/* --- 6. FIRMAS Y APROBACIONES --- */}
            <div style={styles.sectionTitle}>6. FIRMAS Y APROBACIONES</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #003366', marginBottom: '20px' }}>
                <tbody>
                    <tr>
                        {solicitud.departamento === 'PRL' ? (
                            <>
                                {renderFirma(1, 'Firma Solicitante', '', '20%')}
                                {renderFirma(2, 'Recepción Almacén', '', '20%')}
                                {renderFirma(3, 'Aprobación PRL', '', '20%')}
                                {renderFirma(4, 'Aprob. Jefa Mant.', '', '20%')}
                                {renderFirma(5, 'Recepción Admin', '', '20%')}
                            </>
                        ) : solicitud.departamento === 'GENERICO PLANTA' ? (
                            <>
                                {renderFirma(1, 'Firma Solicitante', '', '25%')}
                                {renderFirma(2, 'Recepción Almacén', '', '25%')}
                                {renderFirma(3, 'Aprob. Jefa Mant.', '', '25%')}
                                {renderFirma(4, 'Recepción Admin', '', '25%')}
                            </>
                        ) : solicitud.cp === '579' ? (
                            <>
                                {renderFirma(1, 'Firma Solicitante', '(Gestor)', '20%')}
                                {renderFirma(2, 'Recepción Almacén', '(Oficial Almacén)', '20%')}
                                {renderFirma(3, 'Aprobación JO', '', '20%')}
                                {renderFirma(4, 'Aprobación Jefe CT', '', '20%')}
                                {renderFirma(5, 'Recepción Admin', '', '20%')}
                            </>
                        ) : solicitud.departamento !== 'OPERACION' ? (
                            <>
                                {renderFirma(1, 'Firma Solicitante', '', '16.6%')}
                                {renderFirma(2, 'Revisión Supervisor', `(${solicitud.departamento})`, '16.6%')}
                                {renderFirma(3, 'Recepción Almacén', '', '16.6%')}
                                {renderFirma(4, 'Aprob. Supervisor', '', '16.6%')}
                                {renderFirma(5, 'Aprobación Responsable', '', '16.6%')}
                                {renderFirma(6, 'Recepción Admin', '', '16.6%')}
                            </>
                        ) : (
                            <>
                                {renderFirma(1, 'Firma Solicitante', '(Operación)', '25%')}
                                {renderFirma(2, 'Recepción Almacén', '(Oficial Almacén)', '25%')}
                                {renderFirma(3, 'Aprobación Responsable', '', '25%')}
                                {renderFirma(4, 'Recepción Admin', '', '25%')}
                            </>
                        )}
                    </tr>
                </tbody>
            </table>

            {/* --- RECORDATORIO PROCEDIMIENTO --- */}
            <div style={{ border: '1px solid #d32f2f', padding: '10px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
                <strong style={{ color: '#d32f2f', fontSize: '10px', textTransform: 'uppercase' }}>RECORDATORIO DE PROCEDIMIENTO:</strong>
                <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '9px', color: '#b71c1c' }}>
                    <li style={{ marginBottom: '3px' }}><strong>Repuestos:</strong> La solicitud debe ir acompañada de la oferta recabada por almacén y la firma de aprobación del Responsable de Departamento. El hilo de correo completo se enviará a Administración para lanzar el pedido.</li>
                    <li style={{ marginBottom: '3px' }}><strong>Herramientas:</strong> Los pedidos generales se tramitarán de forma conjunta en enero y julio. Las herramientas específicas requieren justificación expresa.</li>
                    <li><strong>Consumibles:</strong> Los pedidos de consumibles se unificarán por taller, solicitando la reposición cuando el stock alcance un nivel inferior al 20%, evitando los pedidos individuales.</li>
                </ul>
            </div>
            
        </div>
    );
});

const styles = {
    page: { 
        padding: '20px', 
        fontFamily: 'Arial, sans-serif', 
        color: '#000', 
        backgroundColor: '#fff', 
        fontSize: '11px' 
    },
    sectionTitle: {
        backgroundColor: '#003366',
        color: '#fff',
        padding: '6px 10px',
        fontWeight: 'bold',
        fontSize: '11px',
        border: '1px solid #003366',
        borderBottom: 'none' 
    },
    th: { 
        border: '1px solid #003366', 
        padding: '6px', 
        backgroundColor: '#e6f0fa', 
        color: '#003366', 
        fontWeight: 'bold', 
        fontSize: '10px' 
    },
    thCenter: { 
        border: '1px solid #003366', 
        padding: '6px', 
        backgroundColor: '#e6f0fa', 
        color: '#003366', 
        fontWeight: 'bold', 
        fontSize: '10px',
        textAlign: 'center'
    },
    td: { 
        border: '1px solid #003366', 
        padding: '6px', 
        fontSize: '11px', 
        backgroundColor: '#fff' 
    }
};

export default CompraPDFTemplate;